import { ProductType } from 'src/home_page/components/ProductPop/ProductPop'

export const seasonalGiftsExpandData: ProductType = {
  type: 'product',
  title: 'Premium Gifts',
  description:
    'Create an experience with our curated high-end gifts. Designed to make memories that will last a lifetime.',
  categoryId: '328',
}
